<template>
  <div v-if="hasData">
    <v-list-tile class="v-list--two-line">
      <v-list-tile-content>
        <v-list-tile-title>
          <span class="title">
            {{ title }}
          </span>
        </v-list-tile-title>
        <v-list-tile-sub-title>
          {{ description }}
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider v-if="!isLast" />
  </div>
</template>
<script>
  export default {
    props: {
      value: {
        type: Object,
        required: true,
      },
      isFirst: {
        type: Boolean,
        default: false,
      },
      isLast: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      itemData() {
        return JSON.parse(this.value.ItemData)
      },
      title() {
        return this.itemData.title
      },
      description() {
        return this.itemData.description
      },
      hasData() {
        return this.itemData != null &&
          this.itemData.title != null &&
          this.itemData.title != ''
      },
    },
  }
</script>